/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Layout from "~/components/Layout";
import ModalOneButton from "~/components/Modals/OneButtonPopup";
import themes from "~/themes";
import { Content } from "../../styles";

const LoadingCPF = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalText, setModalText] = useState("");
  const { state } = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (state?.data) {
      setTimeout(() => {
        history.replace("/Fatura-Resumo", {
          data: state.data,
        });
      }, 2000);
    }
  }, [state]);

  return (
    <Layout auth={false}>
      <ModalOneButton
        ishtml
        text={modalText}
        buttonText="Ok"
        icon={themes.components.icons.tick}
        visibility={modalIsOpen}
        setVisibility={(bool) => setModalIsOpen(bool)}
        onClose={() => {
          history.push("/fatura-cpf");
        }}
        onClick={() => {
          history.push("/fatura-cpf");
        }}
      />
      <Content>
          <img src={themes.components.images.logoTeuCard} alt="Logo TeuCard" />
          <p>
            <strong>Preparando teus dados</strong>...
          </p>
          <span>Aguarde! Estamos preparando tuas informações!</span>
      </Content>
    </Layout>
  );
};

export default LoadingCPF;
